import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { HistoryComponent } from './pages/history/history.component';
import { ExperienceComponent } from './pages/experience/experience.component';
import { MissionVisionComponent } from './pages/mission-vision/mission-vision.component';
import { OfferedServicesComponent } from './pages/offered-services/offered-services.component';
import { ProjectsImportantComponent } from './pages/projects-important/projects-important.component';
import { OurCustomersComponent } from './pages/our-customers/our-customers.component';
import { OurProposalComponent } from './pages/our-proposal/our-proposal.component';
import { LoginComponent } from './pages/login/login.component';
import { AdminAreaComponent } from './pages/admin-area/admin-area.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { InfoCookiesComponent } from './pages/infor-cookies/infor-cookies.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { ContactsComponent } from './pages/contacts/contacts.component';
import { AuthGuardService } from './auth/auth-guard.service';

const routes: Routes = [
  { path: '', redirectTo: '/homepage', pathMatch: 'full' },
  { path: 'homepage', component: HomepageComponent },
  { path: 'homepage/:section', component: HomepageComponent },
  { path: 'login', component: LoginComponent },
  { path: 'adminarea', component: AdminAreaComponent, canActivate: [AuthGuardService] },
  { path: 'adminarea/:section', component: AdminAreaComponent, canActivate: [AuthGuardService] },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'cookies', component: InfoCookiesComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }